export const publicHelpers = {
  data() {
    return {
      newEmployer: {
        id: 0,
        case_id: 1475,
        created_at: "",
        deleted_at: null,
        employee_img: "img/editable/new_user.png",
        grade: "سمت ",
        mobile: "00000000000",
        updated_at: null,
        user_name: "نام کاربر",
      },
      newProduct: {
        addtostock: 0,
        code: "000",
        created_at: "",
        deleted_at: null,
        detail: "توضیحات کامل محصول یا خدمت",
        gallery: null,
        id: 0,
        image: "img/editable/new_product.png",
        name: "عنوان محصول / خدمت",
        price: "0",
        seller_id: 0,
        status: 1,
        sync_polotik: 0,
        terms_of_sale: null,
        updated_at: "",
      },
      newImageGallery: {
        cat_id: 0,
        category: "عنوان دسته بندی",
        cover: null,
        created_at: "",
        deleted_at: null,
        description: "توضیحات",
        file: ["img/editable/null_image.png"],
        id: 0,
        showIn: "gallery",
        status: 1,
        title: "عنوان",
        type: "image",
        updated_at: "",
        user_id: 0,
        user_type: "vizitori",
      },
      newVideoGallery: {
        cat_id: 0,
        category: "عنوان دسته بندی",
        cover: "img/editable/null_image.png",
        created_at: "",
        deleted_at: null,
        description: "توضیحات",
        file: [],
        id: 0,
        showIn: "gallery",
        status: 1,
        title: "عنوان",
        type: "video",
        updated_at: "",
        user_id: 0,
        user_type: "vizitori",
      },
    };
  },
  methods: {
    getImgUrl(name) {
      var images = require.context("../assets/", true, /\.png$/);
      return images("./" + name);
    },
    phoneChecker(phone) {
      if (phone == null || phone == "" || phone.length < 11) {
        return false;
      }
      if (
        phone !=
        [
          "00000000000",
          "11111111111",
          "22222222222",
          "33333333333",
          "44444444444",
          "55555555555",
          "66666666666",
          "77777777777",
          "88888888888",
          "99999999999",
        ]
      )
        return phone.trim();
    },
  },
};
